import React, { Component } from 'react';
import {
    Alert,
    Badge,
    Card,
    CardHeader,
    CardBody,
    Col,
    Container,
    Row,
    Nav,
    NavItem,
    NavLink,
    TabPane,
    TabContent,
    Table,
    Button
} from 'reactstrap';
import {withRouter, Redirect, Link} from "react-router-dom";

import {ClientAPI, MonitorAPI} from "api";

import {Loading, GoogleMap, Utils} from "custom";

import profileBg from '../../assets/images/monitor-bg.jpg';
import avatarClient from '../../assets/images/avatar/client.jpg';

import TabAnag from "./TabsGest/TabAnag";
import TabSell from "./TabsGest/TabSell";
import TabCertificate from "./TabsGest/TabCertificate";
import TabLive from "./TabsGest/TabLive";
import TabVideocorsi from "./TabsGest/TabVideocorsi";

const moment = require("moment");

class ClientGest extends Component {

    constructor(props) {
        super(props);
        const query = new URLSearchParams(window.location.search)
        const active = query.get('vendita') == 1
        this.state = {
            loading: true,
            error: false,
            client: null,
            tabActive: active ? 2 : 1
        };
        document.title ="Dettagli Cliente | CLTV Cloud";
    }

    componentDidMount() {
        this.getDetailClient()
    }

    getDetailClient() {
        ClientAPI.detail(this.props.match.params.id).then((client) => {
            this.setState({client: client, loading: false})
        }).catch((err) => {
            console.error(err);
            this.setState({error: true})
        })
    }

    deleteClient() {
        const self = this;
        global.SweetAlert.fire({
            title: "Elimina cliente",
            text: 'Attenzione, stai eliminando un cliente, questo comporterà l\'eliminazione di tutti i contratti, campagne e dati associati ad esso. Vuoi procedere??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, elimina',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    ClientAPI.remove(self.state.client.id).then(() => {
                        resolve();
                    }).catch(() => {
                        global.SweetAlert.fire({
                            icon: 'danger',
                            title: 'Si è verificato un errore :(',
                            text: 'Purtroppo qualcosa è andato storto e non è stato possibile eliminare il cliente. Riprova più tardi.',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject()
                    })
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Cliente eliminato!',
                    text: 'Cliente eliminato correttamente.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                window.location.replace("/client");
            }
        })
    }


    render() {

        if (this.state.error) {
            return <React.Fragment>
                <div className="page-content">
                    <Alert color="danger" >Si è verificato un errore durante il recupero dei dettagli del cliente.</Alert>
                </div>
            </React.Fragment>
        }

        const client = this.state.client;
        const user = Utils.getUserData();

        return (
            <React.Fragment>
                {(this.state.loading) ? <Loading /> : <div className="page-content">
                    <Container fluid>
                        <div className="profile-foreground position-relative mx-n4 mt-n4">
                            <div className="profile-wid-bg">
                                <img src={profileBg} alt="" className="profile-wid-img" />
                            </div>
                        </div>
                        <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                            <Row className="g-4">
                                <div className="col-auto">
                                    <div className="avatar-lg">
                                        <img src={avatarClient} alt="user-img"
                                             className="img-thumbnail rounded-circle" />
                                    </div>
                                </div>

                                <Col>
                                    <Link to={"/client"}><Button className="btn btn-sm btn-info" ><i className="ri-arrow-left-circle-line fs-5 text-white-75 align-middle" /> Torna alla lista</Button></Link>
                                    <div className="p-2">
                                        <h3 className="text-white mb-1">{client.firstname} {client.lastname}</h3>
                                        <p className="text-white-75">Cliente</p>
                                        <div className="hstack text-white-50 gap-1">
                                            <div className="me-2">
                                                <i className="ri-map-pin-user-line me-1 text-white-75 fs-16 align-middle"></i>{client.full_address}
                                            </div>
                                        </div>
                                        <div className="hstack text-white-50 gap-1">
                                            <div className="me-2">
                                                <i className="ri-calendar-2-fill me-1 text-white-75 fs-16 align-middle"></i>Creato il: {moment(client.createdAt).format("DD/MM/YYYY")}
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={12} className="col-lg-auto order-last order-lg-0">
                                    <Row className="text text-white-50 text-center">
                                        <Col lg={6} xs={3}>
                                            <div className="p-2">
                                                <h5 className="text-white mb-1">Accesso</h5>
                                                {(client.active) ? <Badge color="success" pill>Attivo</Badge> : <Badge color="danger" pill>Non Attivo</Badge>}
                                            </div>
                                        </Col>
                                        <Col lg={6} xs={3}>
                                            <div className="p-2">
                                                <h5 className="text-white mb-1">ID</h5>
                                                <p className="fs-16 mb-0">{client.id}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>

                        <Row>
                            <Col lg={12}>
                                <div>
                                    <div className="d-flex">
                                        <Nav pills className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                                            <NavItem>
                                                <NavLink
                                                    className={ "cursor-pointer " + ((this.state.tabActive === 2) ? "fs-16 bg-white text-dark" : null)}
                                                    onClick={() => this.setState({tabActive: 2}) }
                                                >
                                                    <i className="ri-user-2-fill d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Anagrafica</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={ "cursor-pointer " + ((this.state.tabActive === 1) ? "fs-16 bg-white text-dark" : null)}
                                                    onClick={() => this.setState({tabActive: 1}) }
                                                >
                                                    <i className="ri-list-unordered d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Vendite</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={ "cursor-pointer " + ((this.state.tabActive === 3) ? "fs-16 bg-white text-dark" : null)}
                                                    onClick={() => this.setState({tabActive: 3}) }
                                                >
                                                    <i className="ri-donut-chart-fill d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Attestati</span>
                                                </NavLink>
                                            </NavItem>
                                            {/*
                                              LEZIONI LIVE. Sta accanto alle Vendite e non dentro,
                                              perche' su CLTV il diritto vive in due posti diversi:
                                              i videocorsi e le classi in `sells`, le lezioni live
                                              in `live_subscriptions` — una riga per cliente, con
                                              quante a settimana e fino a quando.
                                            */}
                                            <NavItem>
                                                <NavLink
                                                    className={ "cursor-pointer " + ((this.state.tabActive === 4) ? "fs-16 bg-white text-dark" : null)}
                                                    onClick={() => this.setState({tabActive: 4}) }
                                                >
                                                    <i className="ri-live-line d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Lezioni live</span>
                                                </NavLink>
                                            </NavItem>
                                            {/* I VIDEOCORSI APERTI SENZA UNA VENDITA (piano SMART). Linguetta a se' e non
                                                dentro «Vendite», perche' e' esattamente il punto: quello che si apre qui NON
                                                e' una vendita e non deve entrare nei conti del gestionale. */}
                                            <NavItem>
                                                <NavLink
                                                    className={ "cursor-pointer " + ((this.state.tabActive === 5) ? "fs-16 bg-white text-dark" : null)}
                                                    onClick={() => this.setState({tabActive: 5}) }
                                                >
                                                    <i className="ri-play-circle-line d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Videocorsi</span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <div className="flex-shrink-0">
                                            <Link to={"/client/edit/" + client.id}>
                                                <button
                                                    type="button"
                                                    className="btn btn-success edit-btn btn-sm">
                                                    <i className="ri-edit-2-fill align-bottom me-1"></i> MODIFICA CLIENTE
                                                </button>
                                            </Link>
                                        </div>
                                    </div>

                                    <TabContent activeTab={String(this.state.tabActive)} className="pt-4">
                                        <TabPane tabId="1">
                                            <TabSell client={client} history={this.props.history}/>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <TabAnag client={client} />
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <TabCertificate client={client} />
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <TabLive client={client} />
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <TabVideocorsi client={client} />
                                        </TabPane>
                                    </TabContent>

                                    <div className="text-center" style={{margin: 10}}>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => this.deleteClient()}>
                                            <i className="ri-delete-bin-2-fill align-bottom"></i> Elimina cliente
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Container>
                </div>}
            </React.Fragment>
        );
    }
}

export default withRouter(ClientGest);
